// extracted by mini-css-extract-plugin
export default {"IntroductionVideoContainer":"IntroductionVideo_IntroductionVideoContainer__3WCnL"};